import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { SearchListComponent } from './list/search-list.component'
import { SearchTreeComponent } from './tree/search-tree.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'tree', component: SearchTreeComponent },
      { path: 'list', component: SearchListComponent },
    ]),
  ],
  exports: [
    RouterModule,
  ],
})
export class SearchRoutingModule {}
